import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  drumLaunge,
  drumLessonroom,
  drumLessonroom2,
  drumPractice,
  drumRestroom,
  drumRoby,
  drumRoby2
} from '../../assets/index';
import { useScrollToTop } from '../../hooks/useScrollToTop';

interface TourLocation {
  id: string;
  title: string;
  description: string;
  image: string;
}

const AcademyTour: React.FC = () => {
  const { t } = useLanguage();

  // 페이지 마운트 시 상단으로 스크롤
  useScrollToTop();

  const tourLocations: TourLocation[] = [
    {
      id: 'lobby',
      title: t('academy_lobby_title'),
      description: t('academy_lobby_description'),
      image: drumRoby
    },
    {
      id: 'lobby1',
      title: t('academy_lobby_title'),
      description: t('academy_lobby_description'),
      image: drumRoby2
    },
    {
      id: 'lessonroom1',
      title: t('academy_lessonroom1_title'),
      description: t('academy_lessonroom1_description'),
      image: drumLessonroom
    },
    {
      id: 'lessonroom1',
      title: t('academy_lessonroom1_title'),
      description: t('academy_lessonroom2_description'),
      image: drumLessonroom2
    },
    {
      id: 'practice',
      title: t('academy_practice_room_title'),
      description: t('academy_practice_room_description'),
      image: drumPractice
    },
    {
      id: 'lounge',
      title: t('academy_lounge_title'),
      description: t('academy_lounge_description'),
      image: drumLaunge
    },
    {
      id: 'restroom',
      title: t('academy_restroom_title'),
      description: t('academy_restroom_description'),
      image: drumRestroom
    }
  ];

  return (
    <div className="academy-tour-page">
      <div className="page-header">
        <div className="page-badge">Academy Tour</div>
        <h1 className="page-title">{t('academy_tour_subtitle')}</h1>
        <p className="page-description">{t('academy_tour_description')}</p>
      </div>

      <div className="page-content">
        <div className="container">

          <div className="form-container" style={{ backgroundColor: 'transparent' }}>
            <div className="tour-grid">
              {tourLocations.map((location) => (
                <div
                  key={location.id}
                  className="tour-location"
                >
                  <div className="location-image">
                    <img src={location.image} alt={location.title} />
                  </div>

                  <div className="location-content">
                    <h3>{location.title}</h3>
                    <p className="description">{location.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcademyTour; 